import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  patch,
  post,
  put,
  get,
} from "helpers/api_helper"
import {
  ADD_BULK_COUPONS,
  ADD_COUPON,
  ADD_COUPON_GROUP,
  ADD_PROMOTION,
  COUPON_USAGE,
  COUPON_USAGE_DETAILS,
  DELETE_COUPON,
  DELETE_COUPON_GROUP,
  DELETE_PROMOTION,
  GET_ALL_COUPONS,
  GET_ALL_COUPONS_LIST,
  GET_ALL_COUPON_GROUPS,
  GET_ALL_COUPON_GROUPS_LIST,
  GET_ALL_PROMOTIONS,
  GET_ALL_PROMOTIONS_LISTS,
  GET_COUPON_DETAILS,
  GET_COUPON_GROUP_DETAILS,
  GET_PROMOTIONS_DETAILS,
  UPDATE_BULK_COUPON_GROUP,
  UPDATE_COUPON,
  UPDATE_COUPON_GROUP,
  UPDATE_COUPON_GROUP_STATUS,
  UPDATE_COUPON_STATUS,
  UPDATE_PROMOTION,
  UPDATE_PROMOTION_STATUS,
} from "helpers/url_helper"

export const getAllPromotions = createAsyncThunk(
  GET_ALL_PROMOTIONS,
  async payload => {
    const response = await post(GET_ALL_PROMOTIONS, payload)
    return response
  }
)

export const getAllPromotionsList = createAsyncThunk(
  GET_ALL_PROMOTIONS_LISTS,
  async payload => {
    const response = await get(GET_ALL_PROMOTIONS_LISTS, payload)
    return response
  }
)

export const updatePromotionStatus = createAsyncThunk(
  UPDATE_PROMOTION_STATUS,
  async payload => {
    const response = await patch(UPDATE_PROMOTION_STATUS, payload)
    return response
  }
)

export const deletePromotion = createAsyncThunk(
  DELETE_PROMOTION,
  async payload => {
    const response = await del(DELETE_PROMOTION, payload)
    return response
  }
)

export const addPromotion = createAsyncThunk(ADD_PROMOTION, async payload => {
  const response = await post(ADD_PROMOTION, payload)
  return response
})

export const getPromotionDetails = createAsyncThunk(
  GET_PROMOTIONS_DETAILS,
  async payload => {
    const response = await post(GET_PROMOTIONS_DETAILS, payload)
    return response
  }
)

export const updatePromotion = createAsyncThunk(
  UPDATE_PROMOTION,
  async payload => {
    const response = await put(UPDATE_PROMOTION, payload)
    return response
  }
)
// COUPONS GROUP
export const getAllCouponsGroup = createAsyncThunk(
  GET_ALL_COUPON_GROUPS,
  async payload => {
    const response = await post(GET_ALL_COUPON_GROUPS, payload)
    return response
  }
)

export const getAllCouponsGroupsList = createAsyncThunk(
  GET_ALL_COUPON_GROUPS_LIST,
  async payload => {
    const response = await get(GET_ALL_COUPON_GROUPS_LIST, payload)
    return response
  }
)

export const updateCouponGroupStatus = createAsyncThunk(
  UPDATE_COUPON_GROUP_STATUS,
  async payload => {
    const response = await patch(UPDATE_COUPON_GROUP_STATUS, payload)
    return response
  }
)

export const deleteCouponGroup = createAsyncThunk(
  DELETE_COUPON_GROUP,
  async payload => {
    const response = await del(DELETE_COUPON_GROUP, payload)
    return response
  }
)

export const addCouponGroup = createAsyncThunk(
  ADD_COUPON_GROUP,
  async payload => {
    const response = await post(ADD_COUPON_GROUP, payload)
    return response
  }
)

export const getCouponGroupDetails = createAsyncThunk(
  GET_COUPON_GROUP_DETAILS,
  async payload => {
    const response = await post(GET_COUPON_GROUP_DETAILS, payload)
    return response
  }
)

export const updateCouponGroup = createAsyncThunk(
  UPDATE_COUPON_GROUP,
  async payload => {
    const response = await put(UPDATE_COUPON_GROUP, payload)
    return response
  }
)

export const updateBulkCouponGroup = createAsyncThunk(
  UPDATE_BULK_COUPON_GROUP,
  async payload => {
    const response = await put(UPDATE_BULK_COUPON_GROUP, payload)
    return response
  }
)
// COUPONS
export const getAllCoupons = createAsyncThunk(
  GET_ALL_COUPONS,
  async payload => {
    const response = await post(GET_ALL_COUPONS, payload)
    return response
  }
)

export const updateCouponStatus = createAsyncThunk(
  UPDATE_COUPON_STATUS,
  async payload => {
    const response = await patch(UPDATE_COUPON_STATUS, payload)
    return response
  }
)

export const deleteCoupon = createAsyncThunk(DELETE_COUPON, async payload => {
  const response = await del(DELETE_COUPON, payload)
  return response
})

export const addCoupon = createAsyncThunk(ADD_COUPON, async payload => {
  const response = await formDataPost(ADD_COUPON, payload)
  return response
})

export const getCouponDetails = createAsyncThunk(
  GET_COUPON_DETAILS,
  async payload => {
    const response = await post(GET_COUPON_DETAILS, payload)
    return response
  }
)

export const updateCoupon = createAsyncThunk(UPDATE_COUPON, async payload => {
  const response = await formDataPut(UPDATE_COUPON, payload)
  return response
})

export const addBulkCoupon = createAsyncThunk(
  ADD_BULK_COUPONS,
  async payload => {
    const response = await formDataPost(ADD_BULK_COUPONS, payload)
    return response
  }
)

export const getAllCouponsList = createAsyncThunk(
  GET_ALL_COUPONS_LIST,
  async payload => {
    const response = await get(GET_ALL_COUPONS_LIST, payload)
    return response
  }
)

// COUPON USAGE
export const getAllCouponUsage = createAsyncThunk(
  COUPON_USAGE,
  async payload => {
    const response = await post(COUPON_USAGE, payload)
    return response
  }
)

export const getCouponUsageDetails = createAsyncThunk(
  COUPON_USAGE_DETAILS,
  async payload => {
    const response = await post(COUPON_USAGE_DETAILS, payload)
    return response
  }
)
